import React, { useState, useEffect } from 'react';
import { serverPHP } from '../const/consts';

const WaitingRoom = ({ user, setUser, isAdmin, goNext }) => {

  useEffect(() => {
    // Initialiser l'état prêt à false au début
    setUser(prevUser => ({ ...prevUser, isready: false }));
  }, [setUser]);

  const handleReadyToggle = async () => {
    const newReadyState = !user.isready;
    
    // Mise à jour optimiste
    setUser(prevUser => ({ ...prevUser, isready: newReadyState }));
    
    try {
      const response = await fetch(`${serverPHP}updateUser.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: user.id,
          name: user.name,
          role: user.role,
          currentsession: user.currentsession,
          isready: newReadyState ? 1 : 0
        })
      });
      
      const data = await response.json();
      
      if (!data.success) {
        // Annuler la mise à jour optimiste en cas d'erreur
        setUser(prevUser => ({ ...prevUser, isready: !newReadyState }));
        console.error('Failed to update ready state:', data.error);
      }
    } catch (error) {
      // Annuler la mise à jour optimiste en cas d'erreur
      setUser(prevUser => ({ ...prevUser, isready: !newReadyState }));
      console.error('Error updating ready state:', error);
    }
  };

  const handleRoleChange = (newRole) => {
    setUser(prevUser => ({ ...prevUser, role: newRole }));
  };

  const roleOptions = [
    {
      id: 0,
      emoji: '🖊️',
      title: 'Rédacteur',
      description: 'Vous rédigez et vous évaluez',
      detailedDescription: "Le rôle de rédacteur consiste à écrire des contributions. Vous participerez également à l'évaluation de toutes les contributions."
    },
    {
      id: 1,
      emoji: '⭐',
      title: 'Évaluateur',
      description: 'Vous ne rédigez pas mais vous évaluez',
      detailedDescription: "Le rôle d'évaluateur consiste à donner votre avis sur les contributions produites par les rédacteurs."
    },
    {
      id: 2,
      emoji: '👁️',
      title: 'Spectateur',
      description: 'Vous ne rédigez pas et n\'évaluez pas',
      detailedDescription: "Le rôle de spectateur vous permet de suivre ce qui se passe dans la session, sans jamais intervenir."
    }
  ];

  const selectedRole = roleOptions.find(role => role.id === user.role);

  return (
    <div className="fade-in space-y-6">
      <div className="card">
        <h2 className="card-title">⏳ Salle d'attente</h2>
        
        {/* Section rôle */}
        <div className="role-selection-section">
          <div className="mb-4">
            <p className="text-secondary">
              Sélectionnez votre <strong>rôle</strong> dans cette session. Vous pourrez le changer à tout moment 
              en cliquant sur votre nom en haut à gauche.
            </p>
          </div>
          
          <div className="form-group">
            <label className="form-label">🎭 Votre rôle</label>
            <div className="role-tiles">
              {roleOptions.map((role) => (
                <div
                  key={role.id}
                  className={`role-tile ${user.role === role.id ? 'selected' : ''}`}
                  onClick={() => handleRoleChange(role.id)}
                >
                  <div className="role-emoji">{role.emoji}</div>
                  <div className="role-title">{role.title}</div>
                  <div className="role-description">{role.description}</div>
                </div>
              ))}
            </div>
          </div>
          

        </div>

        <div className="waiting-status">
          <div className="text-4xl mb-3">🚀</div>
          <p className="font-medium">En attente des autres participants...</p>
          <p className="text-sm text-secondary">La session commencera automatiquement quand tout le monde sera prêt.</p>
        </div>

        {/* Section bouton prêt */}
        <div className="ready-section">
          <button
            onClick={handleReadyToggle}
            className={`ready-button ${user.isready ? 'ready-active' : 'ready-inactive'}`}
          >

            <span className="ready-text">
              {user.isready ? 'En attente des autres...' : 'Je suis prêt !'}
            </span>
          </button>

        </div>
      </div>
    </div>
  );
};

export default WaitingRoom;